var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',{staticClass:"wt-asset-footer wt2-sg"},[_c('wt-button',{attrs:{"type":"transparent","text":"Cancel"},on:{"click":_vm.cancel}}),_vm._v(" "),_c('wt-button',{attrs:{"type":"primary","text":"Save & Close"},on:{"click":_vm.done}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }